exports = module.exports = require("../../../../../node_modules/fast-css-loader/lib/css-base.js")(false);
// imports

// module
exports.push([module.id, ".promote-snippet {\n  padding: 1rem 1.5rem;\n  background-color: #f1f1f1; }\n  .promote-snippet h3 {\n    margin-bottom: 1rem; }\n", ""])